import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'
import { searchInstallment } from '../../../redux/actions/projectBasedItems'
import VoucherListWidget from '../../../widgets/projectBasedItemsWidget/VoucherListWidget'
import { useHistory } from 'react-router-dom'

export default function VoucherList() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('projectCode')
  const { periodNo, periodNumber, periodOfLength } = sessionGetItemObj('periodInfo')

  const history = useHistory()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await searchInstallment({}, projectCode, periodNumber)
      console.log('getPeriodicManagement 1234 ', _schema)
      setSchema(_schema.model)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isIncomeExpense>
      <ContentHeader
        header={schema?.header || 'รายละเอียดการบันทึก รับ-จ่าย'}
        subHeader={''}
        isNotCallApi
        isShowGoButton
      />

      {/* 
      periodNo งวดปัจจุบัน (ตัวเลข)
      periodNoText งวดปัจจุบัน (ข้อความ)
      periodOfLength จำนวนงวดทั้งหมด 
      */}
      <VoucherListWidget
        schema={schema}
        periodNoText={periodNo}
        periodNo={periodNumber}
        periodOfLength={periodOfLength}
        projectCode={projectCode}
      />

      <br />
    </SidebarProposal>
  )
}
